var React = require('react');

function Hours (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"14","cy":"14","r":"8.5","stroke":"white","key":0}),React.createElement("path",{"d":"M14 9L14 14L17 17","stroke":"white","key":1})]);
}

Hours.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Hours;

Hours.default = Hours;
